<template>
  <!-- 线上精品课-首页 -->
  <div class="onlineCourse">
    <div class="onlineCon">
      <talentTitle title="线上精品课程" style="margin-top:18px">
        <template #subTitle>
          <div class="box-con">
            <div class="box-con-btn" :class="curIndex === '' ? 'btn-select' : 'btn-normal'" @click="clickCourse('')">
              全部
            </div>
            <div class="box-con-btn" :class="curIndex === item.subjectId ? 'btn-select' : 'btn-normal'"
              v-for="item in onlineTypeList" :key="item.subjectId" @click="clickCourse(item.subjectId)">
              {{ item.subjectName }}
            </div>
          </div>
        </template>
        <template #btn>
          <div class="curp" @click="onClickCourseMore" style="width:70px">
            查看更多
          </div>
        </template>
      </talentTitle>
      <div class="wow animate__animated animate__slideInLeft courseCon">
        <div v-for="(item, index) in courseList" :key="index" class="courseItem" @click="onClickDetail(item)">
          <div class="courseItem-top">
            <div class="courseItem-top-bg" :style="{
              backgroundImage: `url(https://static.zhuzaocloud.com/${item.logo})`,
            }"></div>
            <div class="courseItem-top-title over-num-lines num2-lines">{{ item.courseName }}</div>
          </div>
          <div class="courseItem-bottom">
            <div class="courseItem-bottom-num">
              <i class="el-icon-view iconView" />{{ item.viewcount }}
            </div>
            <!--￥{{ item.sourceprice }} -->
            <div class="courseItem-bottom-price">免费</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import talentTitle from "./talentTitle.vue"
import { getCourseList, getCourseType } from "../../utils/interface"
export default {
  name: "",
  components: { talentTitle },
  props: {},
  data() {
    return {
      onlineTypeList: [
        { subjectName: "数字化转型", subjectId: "1" },
        { subjectName: "智能制造", subjectId: "2" },
        { subjectName: "生产管理", subjectId: "3" },
        { subjectName: "安全教育", subjectId: "4" },
        { subjectName: "经营管理", subjectId: "5" },
      ],
      curIndex: "", //当前位置
      courseList: [
        {
          logo: require("../../assets/publicService/talentService/55.png"),
          courseName: "金属材料的力学性能的力学性能",
          viewcount: 24455,
          sourceprice: 199,
        },
      ],
    }
  },
  watch: {},
  computed: {},
  created() { },
  mounted() {
    this.getCourseType()
    this.getCourseList("")
  },
  methods: {
    // 获取线上精品课程分类
    getCourseType() {
      getCourseType().then((res) => {
        if (res.data && res.data.length > 0) {
          this.onlineTypeList = res.data
        } else {
          this.onlineTypeList = []
        }
      })
    },
    // 线上精品课程-查看更多
    onClickCourseMore() {
      let route = this.$router.resolve({
        path: "/onlineCourseList",
      })
      window.open(route.href, "_blank")
    },
    // 直播公开课详情
    onClickDetail(item) {
      let routeData = this.$router.resolve({
        path: "/onlineCourseDetail",
        query: {
          courseId: item.courseId,
          type: "course",
          titleName: "在线精品课程详情",
          titleForm: "onlineCourseDetail",
        },
      })
      window.open(routeData.href, "_blank")
    },
    // 点击课程分类
    clickCourse(subjectId) {
      this.curIndex = subjectId
      this.getCourseList(subjectId)
    },
    // 根据课程分类id获取课程列表
    getCourseList(subjectId) {
      getCourseList({
        current: "1",
        pageSize: "8",
        subjectId: subjectId,
        courseName: "",
      }).then((res) => {
        if (res.list && res.list.length > 0) {
          console.log("courseList", res.list)
          this.courseList = res.list
        } else {
          this.courseList = []
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.onlineCourse {
  height: 560px;
  background-color: #f6f6f6;
  margin-bottom: -80px;

  .curp {
    cursor: pointer;

    &:hover {
      color: #2d50a1;
    }
  }

  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .num2-lines {
    -webkit-line-clamp: 2;
  }

  .onlineCon {
    width: 1300px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    justify-items: center;

    .box-con {
      display: flex;
      flex-flow: row wrap;
      padding-left: 20px;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
      max-width: 1000px;
      height: 32px;
      overflow: hidden;

      .box-con-btn {
        margin-left: 2px;
        padding: 4px 8px;
        border-radius: 6px;
        cursor: pointer;
      }

      .btn-normal {
        color: #000;
        // background-color: #cedbec;
      }

      .btn-select {
        color: #fff;
        background-color: #2646a4;
      }
    }

    .courseCon {
      width: 100%;
      height: 490px;
      display: flex;
      flex-flow: row wrap;
      // justify-content: space-between;
      // align-items: center;

      .courseItem {
        width: 300px;
        height: 225px;
        border-radius: 12px;
        box-shadow: 0 0 5px #999;
        // border: 1px solid #efefef;
        box-sizing: border-box;
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;
        transition: all 0.2s;
        margin: 0 12px;

        &:hover {
          transform: scale(1.02);
          cursor: pointer;
        }

        .courseItem-top {
          .courseItem-top-bg {
            height: 145px;
            background-repeat: no-repeat;
            // background-size: 100% 100%;
            background-size: 310px 175px;
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
          }

          .courseItem-top-title {
            padding: 4px 10px;
            font-weight: 600;
            height: 40px;
          }
        }

        .courseItem-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 4px 10px 8px;
          font-size: 14px;

          .courseItem-bottom-num {
            color: #8a8a8a;

            .iconView {
              margin-right: 3px;
            }
          }

          .courseItem-bottom-price {
            color: #2d50a1;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/talentServices/onlineCourse.vue